export const environment = {
  appName: 'BIOMAF',
  production: false,
	version: 'test',
  api: {
    baseUrl: 'https://biomaf.test.irevolution-group.com/api',
  },
  featureFlags: {
    enableItems: true,
  }
} as const;
